import { createFileRoute } from "@tanstack/react-router";
import DigitalWorkers from "@/pages/DigitalWorkers";
import { pageHead } from "@/lib/seo";
import { agentsItemListJsonLd } from "@/lib/agents";

export const Route = createFileRoute("/zh/digital-workers")({
  head: () => ({
    ...pageHead("/digital-workers", "zh"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(agentsItemListJsonLd("zh")),
      },
    ],
  }),
  component: DigitalWorkers,
});
